
import { BaseChatPackage } from '../utils'
import { ChatMember } from '@packages/chat'
import { QueryManager } from '@codeleap/query'

export class MembersQuery extends BaseChatPackage {
  public manager: QueryManager<ChatMember & { id: string }>
  public LIMIT = 15

  constructor(...args: ConstructorParameters<typeof BaseChatPackage>) {
    super(...args)
    // @ts-ignore
    this.manager = buildMembersManager(args[0])
  }

  useMemberList({ channelId, limit = this.LIMIT }: { channelId: string, limit?: number }) {
    const members = this.manager.useList({
      limit,
      queryOptions: {
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        staleTime: 0,
        gcTime: 0,
      },
      filter: {
        channelId: channelId,
      },
    })

    return members
  }

  invalidateMembers(channelId: string) {
    return this.manager.queryClient.invalidateQueries({
      queryKey: this.manager.filteredQueryKey({ channelId }),
    })
  }

  updateMemberItem(member: ChatMember) {
  }
}

function buildMembersManager({ queryClient, chatApi }: ConstructorParameters<typeof BaseChatPackage>[0]) {
  return new QueryManager<ChatMember & {id: string}>({
    itemType: {} as ChatMember & {id: string},
    name: 'members',
    queryClient: queryClient.client,
    limit: 15,
    listItems: async (limit, offset, filters) => {
      const response = await chatApi.listMembers(
        filters.channelId,
        {
          limit,
          offset,
          ...filters,
        },
      )
      if (response.ok) {
        return {
          ...response.data,
          // We need that because Stream doesn't return an id field, but react-query needs it
          results: response.data?.results.map(m => ({ ...m, id: m.user_id })) || [],
        }
      }
      return {
        results: [],
        total: 0,
        count: 0,
        offset: 0,
        next: null,
        previous: null,
      }
    }
  })
}

